import api from "./interceptor";

export const getRequest = async (endpoint, config = {}) => {
  return await api.get(endpoint, config);
};

export const postRequest = async (endpoint, data, config = {}) => {
  return await api.post(endpoint, data, config);
};

export const putRequest = async (endpoint, data, config = {}) => {
  return await api.put(endpoint, data, config);
};

export const deleteRequest = async (endpoint, config = {}) => {
  return await api.delete(endpoint, config);
};
